import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useRemoveRole } from "@/hooks/queries/user";
import { useAuthorization } from "@/modules/authorization";

const UserRoleRemoveButton = ({ role, userId }) => {
  const { t } = useTranslation();
  const mutation = useRemoveRole("users", userId);
  const { canManageRole } = useAuthorization();

  const removePermission = (behavior, role) => {
    mutation.mutate({
      behavior,
      subject_id: role?.subject_id || null,
    });
  };

  return (
    <Button
      onClick={() => removePermission(role.behavior, role)}
      disabled={!canManageRole(role.subject)}
      loading={mutation.isPending}
    >
      {t("user:removePermission")}
    </Button>
  );
};

UserRoleRemoveButton.propTypes = {
  role: PropTypes.object.isRequired,
  userId: PropTypes.number.isRequired,
};

export default UserRoleRemoveButton;
